import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  readDashboardDataRevision,
  subscribeDashboardDataRevision,
} from '../utils/dashboardRefreshCoordinator';

function isDashboardHomePath(pathname = '') {
  return pathname === '/dashboard/' || pathname === '/dashboard';
}

/**
 * Tracks dashboard data revision for calendar + pending tasks refresh coordination.
 *
 * Re-syncs when navigating back to /dashboard/ so mutations from housekeeping
 * (maintenance block, etc.) are visible without a hard refresh.
 */
export default function useDashboardDataRevision() {
  const location = useLocation();
  const [dataRevision, setDataRevision] = useState(() => readDashboardDataRevision());

  const syncRevision = useCallback(() => {
    setDataRevision(readDashboardDataRevision());
  }, []);

  useEffect(() => subscribeDashboardDataRevision((revision) => {
    setDataRevision(revision);
  }), []);

  useEffect(() => {
    if (isDashboardHomePath(location.pathname)) {
      syncRevision();
    }
  }, [location.pathname, syncRevision]);

  return { dataRevision, syncRevision, isDashboardHome: isDashboardHomePath(location.pathname) };
}
